import axios from 'axios';
import { zynity_api } from '../../config/external-routes';

export type PasswordForgotResponse = {
  message: string;
};

export type PasswordValidateResponse = {
  message: string;
};

export type PasswordResetResponse = {
  message: string;
};

export const requestPasswordResetEmail = async (email: string): Promise<PasswordForgotResponse> => {
  const response = await axios.post(zynity_api.password_forgot, { email });
  return response.data;
};

export const validatePasswordResetToken = async (params: {
  sc: string;
  ts: number;
}): Promise<PasswordValidateResponse> => {
  const response = await axios.get(zynity_api.password_validate, { params });
  return response.data;
};

export const resetPasswordWithToken = async (params: {
  sc: string;
  ts: number;
  newPassword: string;
  newPasswordRepeat: string;
}): Promise<PasswordResetResponse> => {
  const response = await axios.post(zynity_api.password_reset, params);
  return response.data;
};
